import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form/immutable';

import SelectBox from '../common/SelectBox';
import * as constraints from '../../utils/constraints';
import { userTypeOptions } from '../../constants/constants';

const UserTypeForm = ({ handleSubmit }) => (
  <form onSubmit={handleSubmit}>
    <div>
      <Field
        name="type"
        label="Tipo de Usuario"
        options={userTypeOptions}
        placeholder="Seleccione el tipo de Usuario"
        component={SelectBox}
      />
    </div>
    <button className="default-button" type="submit">
      Continuar
    </button>
  </form>
);

const { func } = PropTypes;

UserTypeForm.propTypes = {
  handleSubmit: func.isRequired
};

export default reduxForm({
  form: 'signUp',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: constraints.validations(constraints.userType)
})(UserTypeForm);



// WEBPACK FOOTER //
// ./src/components/user/UserTypeForm.js